import { render, staticRenderFns } from "./PageBoutique.vue?vue&type=template&id=be08c0cc&"
import script from "./PageBoutique.vue?vue&type=script&lang=js&"
export * from "./PageBoutique.vue?vue&type=script&lang=js&"
import style0 from "./PageBoutique.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports